import type { FormTranslations } from "../../types/forms";

export const forms: FormTranslations = {
  validation: {
    required: "See v\u00E4li on kohustuslik",
    minLength: "Peab olema v\u00E4hemalt {min} t\u00E4hem\u00E4rki",
    maxLength: "Ei tohi olla pikem kui {max} t\u00E4hem\u00E4rki",
    pattern: "Vale formaat",
    email: "Peab olema kehtiv e-posti aadress",
    number: "Peab olema kehtiv number",
    date: "Peab olema kehtiv kuup\u00E4ev",
    invalidYear: "Palun sisestage kehtiv aasta (AAAA)",
    emailRequired: "E-posti aadress on n\u00F5utav",
    fieldsRequired:
      "Palun kontrollige, et k\u00F5ik n\u00F5utud v\u00E4ljad on \u00F5igesti t\u00E4idetud.",
    invalidName: "Kehtetu nimi",
    orgNameMinLength: "Organisatsiooni nimi peab olema v\u00E4hemalt 2 t\u00E4hem\u00E4rki",
    error: "Valideerimise viga",
  },
  buttons: {
    submit: "Esita",
    cancel: "Tühista",
    save: "Salvesta",
    edit: "Muuda",
  },
  status: {
    saving: "Töötlemine...",
    saved: "Edukalt salvestatud",
    error: "Viga andmete salvestamisel",
  },
  login: {
    title: "Logi Sisse",
    description: "Sisestage oma andmed konto juurdepääsuks",
    heading: "Logi sisse ja küsi Franklinilt",
    taglines: [
      "Küsi hoonelt. See oli kogu aeg kohal.",
      "Teadmine sünnib seostest.",
      "Sa ei saa jälgida seda, mida sa ei saa võrrelda.",
      "Teadmine võidab oletamise. Iga kord.",
      "Kõigepealt korrasta. Siis tead.",
      "Muutused on pidevad. Nende kaotsiminek mitte.",
      "Kuskil kaustas nr 47 on vastus olemas.",
      "Parim joonise versioon on see, mille sa ka üles leiad.",
      "Keegi pole kunagi öelnud: „Soovin, et selles projektis oleks rohkem kaustu.”",
      "„Final_v3_REAL_final.dwg” ei ole versioonihaldus.",
    ],
    newHere: "Esimest korda siin?",
    bookDemo: "Broneeri demo",
    emailLabel: "E-post",
    passwordLabel: "Parool",
    forgotPassword: "Unustasid parooli?",
    submitButton: "Logi Sisse",
    noAccountYet: "Pole veel kontot?",
    signUpLink: "Registreeru",
    emailPlaceholder: "sina@ettevote.ee",
    passwordPlaceholder: "Sisesta oma parool",
    privacyText: "Registreerimisega nõustud meie tingimuste ja privaatsuspoliitikaga",
    selectOrganization: "Vali organisatsioon",
    noOrganizations: "Organisatsioonid puuduvad",
    organizationRequired: "Palun vali organisatsioon",
    verifyEmailNotice: "Palun kinnita oma e-posti aadress enne sisselogimist.",
  },
  signup: {
    title: "Loo konto",
    description: "Registreeru alustamiseks",
    firstNameLabel: "Eesnimi",
    lastNameLabel: "Perekonnanimi",
    organizationLabel: "Organisatsioon",
    organizationPlaceholder: "Sisesta organisatsiooni nimi",
    organizationRequired: "Organisatsiooni nimi on kohustuslik",
    terms: "Nõustun tingimustega",
    termsRequired: "Pead nõustuma tingimustega",
    submitButton: "Registreeru",
  },
  passwordReset: {
    title: "Lähtesta Parool",
    checkEmailTitle: "Kontrolli Oma E-posti",
    description: "Sisesta oma e-posti aadress parooli lähtestamise juhiste saamiseks",
    checkEmailDescription:
      "Kui selle e-postiga on konto olemas, saadame sulle parooli lähtestamise juhised.",
    newPasswordLabel: "Uus Parool",
    confirmPasswordLabel: "Kinnita Parool",
    sendInstructionsButton: "Saada Lähtestamise Juhised",
    resetPasswordButton: "Lähtesta Parool",
    backToLogin: "Tagasi sisselogimisele",
    resetSuccess: "Parool on edukalt lähtestatud",
    passwordMismatch: "Paroolid ei ühti",
    passwordTooShort: "Parool peab olema vähemalt 8 tähemärki pikk",
    enterCodeTitle: "Sisesta Kinnituskood",
    enterCodeDescription: "Sisesta e-postile saadetud 6-kohaline kood",
    verificationCode: "Kinnituskood",
    verifyCodeButton: "Kinnita Kood",
    sendCodeButton: "Saada Kinnituskood",
    codeExpires: "Kood aegub",
    seconds: "sekundit",
    resendCode: "Saada Kood Uuesti",
    codeVerified: "Kood edukalt kinnitatud",
    newPasswordTitle: "Määra Uus Parool",
    newPasswordDescription: "Sisesta oma uus parool",
    invalidCode: "Palun sisesta kehtiv 6-kohaline kood",
    incorrectCode: "Vale kinnituskood",
    codeExpired: "Kinnituskood on aegunud",
    noCodeFound: "Kinnituskoodi ei leitud",
    checkEmailForCode: "Palun kontrolli oma e-posti kinnituskoodi saamiseks",
    verifying: "Kontrollin parooli lähtestamise linki...",
    invalidToken: "Parooli lähtestamise link on kehtetu või aegunud. Palun taotle uus.",
    requestNewResetLinkButton: "Taotle uut lähtestamise linki",
  },
  passwordStrength: {
    veryWeak: "V\u00e4ga n\u00f5rk",
    weak: "N\u00f5rk",
    fair: "Rahuldav",
    good: "Hea",
    strong: "Tugev",
    invalid: "Kehtetu",
  },
  error: {
    allFieldsRequired: "Kõik väljad on kohustuslikud",
    invalidCredentials: "Vale e-post või parool",
    unexpectedError: "Tekkis ootamatu viga",
    tooManyAttempts: "Liiga palju sisselogimiskatseid. Palun proovige hiljem uuesti.",
    invalidEmail: "Palun sisestage kehtiv e-posti aadress",
  },
  success: {
    loginSuccessful: "Sisselogimine õnnestus",
    signupSuccessful: "Registreerimine õnnestus!",
    checkEmail: "Palun kontrollige oma e-posti, et jätkata",
    passwordResetSent: "Parooli lähtestamise juhised on saadetud teie e-postile",
    passwordResetSuccess: "Parool on edukalt lähtestatud",
  },
  showPassword: "Näita parooli",
  hidePassword: "Peida parool",
  constructionType: "Ehituse tüüp",
  floors: "Korruste arv",
  parkingSpaces: "Parkimiskohad",
  energyRating: "Energiamärgis",
  lastRenovationDate: "Viimase renoveerimise kuup\u00E4ev",
  createOrganization: {
    title: "Loo oma organisatsioon",
    description: "Seadista oma organisatsioon, et alustada hoonete haldamist",
    name: "Organisatsiooni nimi",
    placeholder: "nt Franklin Corporation",
    submit: "Loo organisatsioon",
    signedInAs: "Sisse logitud kui {email}",
    signOut: "Logi välja",
  },
};
